import styled from 'styled-components';
import { Button } from '@material-ui/core';

const ButtonStyled = styled(Button)`
  background-color: #169aff;
  color: #f9f9f9;
`;

export default ButtonStyled;
